(function (Drupal) {
  Drupal.behaviors.changeReadMoreText = {
    attach: function (context, settings) {
      // Seleccionar todos los elementos con la clase 'card-doctor'
      const cardDoctors = document.querySelectorAll('.card-doctor', context);

      cardDoctors.forEach(card => {
        // Seleccionar el elemento hijo con la clase 'node-readmore'
        const readMoreNode = card.querySelector('.node-readmore');
        
        if (readMoreNode) {
          // Seleccionar el elemento <a> dentro de 'node-readmore'
          const readMoreLink = readMoreNode.querySelector('a');
          
          if (readMoreLink) {
            // Cambiar el texto 'Lee más' a 'ver CV' solo en el nodo de texto directo del <a>
            let textNode = readMoreLink.childNodes[0];
            if (textNode && textNode.nodeType === 3) { // Asegurarse de que es un nodo de texto
              textNode.nodeValue = textNode.nodeValue.replace('Lee más', 'Ver Cv');
            }
          }
        }
      });
    }
  };
})(Drupal);
